import React from "react";
import { Navigate } from "react-router-dom";
import { useRouterStore } from "../../libs/stores";
import { collectAccessibleRoutes } from "../../libs/helpers";
import { BaseModuleI } from "../../libs/interfaces";
import { ElLoader } from "../../libs/shared";
import { NoAcceso } from "./NoAcceso";

const normalizeModuleOptions = (module: BaseModuleI): BaseModuleI => {
  if (!module.options && !module.children) {
    return module; // No hay nada que normalizar
  }

  const normalizedOptions = module.options?.map((option) => {
    if (option.to.startsWith(module.to)) {
      return {
        ...option,
        to: option.to.replace(module.to, "").replace(/^\/+/, ""),
      };
    }
    return option;
  });

  const normalizedChildren = module.children?.map(normalizeModuleOptions);

  return {
    ...module,
    options: normalizedOptions,
    children: normalizedChildren,
  };
};

const PageRedirect = ({elroute}: {elroute: string}) => {
  const modules = useRouterStore((state) => state.modules);
  const moduleMap = useRouterStore((state) => state.moduleMap);
  const isLoading = useRouterStore((state) => state.isLoading); // Suponiendo que tienes un estado de carga

  if (isLoading) {
    return <ElLoader/>
  }

  if (!modules || modules.length === 0) {
    return <NoAcceso/>
  }

  const checkModule = moduleMap[elroute];

  if (!checkModule) {
    return (
      <div>
        <h1 style={{ color: "red" }}>Acceso denegado</h1>
        <p>No tienes acceso a ningún módulo en esta sección.</p>
      </div>
    );
  }

  const normalizedModule = normalizeModuleOptions(checkModule);

  const accessibleRoutes = collectAccessibleRoutes([normalizedModule]);

  const accessibleRoute = accessibleRoutes[0];

  if (!accessibleRoute) {
    return (
      <div>
        <h1 style={{ color: "red" }}>Acceso denegado</h1>
        <p>No tienes acceso a ningún módulo en esta sección.</p>
      </div>
    );
  }

  return <Navigate to={accessibleRoute} replace />;
};

export default PageRedirect;
